import { Subtitle } from 'components/Typography'
import tw from 'twin.macro'

const Header = () => {
  return (
    <div css={tw`text-center`}>
      <Subtitle>Primary Research - Himachal Pradesh</Subtitle>
    </div>
  )
}

export default Header
